export class ProviderEventEmitter {
  constructor() {
    this.listeners = {
      accountsChanged: [],
      chainChanged: [],
      connect: [],
      disconnect: [],
      display_uri: [],
      message: [],
    };
  }

  on(event, listener) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(listener);
  }

  removeListener(event, listener) {
    if (!this.listeners[event]) {
      return;
    }
    this.listeners[event] = this.listeners[event].filter(
      (registered) => registered !== listener
    );
  }

  emit(event, data) {
    if (!this.listeners[event]) {
      return;
    }
    this.listeners[event].forEach((listener) => {
      try {
        listener(data);
      } catch {
        // Swallow listener errors to avoid breaking emitter chain
      }
    });
  }
}

